import { Box, Container, Typography } from "@mui/material";
import React from "react";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import Navbar from "../../components/HomeLandingPage/Home/NavBar/Navbar";
import Footer from "../../components/HomeLandingPage/Home/Footer/Footer";
// import AffordablePricing from "../../components/HomeLandingPage/Home/AffordablePricing/AffordablePricing";
import PrivacyFAQ from "../../components/Settings/PrivacyTab/PrivacyFAQ";

const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const AnimatedSection = ({ children }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px 0px -50px 0px" });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={sectionVariants}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const PrivacyPolicy = () => {
  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          paddingRight: "25px",
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Navbar />
      </Box>

      {/* Banner Section */}
      <Box
        sx={{
          backgroundColor: "#000",
          color: "#fff",
          textAlign: "center",
          py: { xs: 6, md: 10 },
          px: 3,
        }}
      >
        <Container maxWidth="md">
          <AnimatedSection>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 600,
                mb: 2,
                fontSize: { xs: "2rem", md: "3rem" },
              }}
            >
              Privacy Policy
            </Typography>
            <Typography
              sx={{
                textAlign: "justify",
                hyphens: "auto",
                fontSize: { xs: "0.9rem", md: "1rem" },
                opacity: 0.8,
              }}
            >
              Welcome to GX Tickets, your ultimate destination for seamless event
              management and hassle-free ticket booking. At GX Tickets, we believe
              in making every event an unforgettable experience. Our platform is
              designed to connect event organizers with their audiences, providing
              a streamlined process for creating, promoting, and managing events
              of all sizes.
            </Typography>
          </AnimatedSection>
        </Container>
      </Box>

      {/* Policy Section */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <AnimatedSection>
          <Section title="1. Use of Services" content="You must be at least 18 years old to use GX Tickets." />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="2. User Content" content="You retain all rights to the content you upload." />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="3. Intellectual Property" content="GX Tickets and its original content, features, and functionality are protected by intellectual property laws." />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="4. Payment and Subscription" content="Some features of GX Tickets may require payment of fees." />
        </AnimatedSection>
        <AnimatedSection>
          <Section
            title="5. Google Contact Access"
            content="GX Tickets may request access to your Google Contacts when you choose to connect your Google account. This is done using the scope: https://www.googleapis.com/auth/contacts.readonly. This access allows GX Tickets to display your saved Google contacts (name and email) so you can easily select invitees when organizing events. We do not store, share, or use your contact data for any other purpose. All contact data is handled securely, used only temporarily in your session, and never saved to our servers. You can revoke access anytime via your Google Account settings. We comply with Google’s API Services User Data Policy and all applicable privacy regulations."
          />
        </AnimatedSection>
        <AnimatedSection>
          <Section
            title="6. Location Data"
            content="GX Tickets may request access to your device’s location (precise or approximate) when you use features such as exploring events on a map, discovering events near you, or creating an event and choosing to use your current location. Location access is optional and only collected when you grant permission through your device or browser. We use location data to display your position on event maps, help you find nearby events, and pre-fill event venue addresses during event creation. Location coordinates may be sent to our mapping provider (Mapbox) to render maps and convert coordinates into readable addresses. We do not sell your location data and do not use it for advertising. We do not retain your real-time device location on our servers; only event venue information you explicitly save as part of an event is stored. You can revoke location access at any time through your device or browser settings."
          />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="7. Termination" content="You may terminate your account at any time." />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="8. Disclaimer of Warranties" content="GX Tickets is provided 'as is' without any warranties." />
        </AnimatedSection>
        <AnimatedSection>
          <Section title="9. Contact Us" content="If you have any questions about this Privacy Policy or how we use your information, please contact us at support@gxtickets.com." />
        </AnimatedSection>
        <AnimatedSection>
          <Section
            title="10. Google User Data Retention and Deletion"
            content="GX Tickets does not store any Google user data obtained through your Google account. When you connect your Google Contacts to select invitees, the contact data is accessed only temporarily during your session and is never saved to our servers. No data is retained once the session ends. You can revoke access to your Google account at any time through your Google Account settings. Since we do not store your Google data, no additional deletion is necessary."
          />
        </AnimatedSection>
      </Container>

      <AnimatedSection>
        <Box sx={{ mt: { xs: 1, md: 2 } }}>
          <PrivacyFAQ />
        </Box>
      </AnimatedSection>

      <Box sx={{ mt: { xs: 15, md: 15 } }}>
        <Footer />
      </Box>
    </>
  );
};

const Section = ({ title, content }) => (
  <Box mb={4}>
    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: "#333" }}>
      {title}
    </Typography>
    <Typography sx={{ color: "#555", lineHeight: "1.6" }}>
      {content}
    </Typography>
  </Box>
);

export default PrivacyPolicy;